var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Slidebar',{attrs:{"large":true},on:{"closeMe":_vm.closeSlidebar}},[_c('h4',[_vm._v("Viðvera nemanda")]),(_vm.studentId)?_c('StudentInfo',{staticStyle:{"margin-bottom":"-10px"},attrs:{"id":_vm.studentId}}):_vm._e(),(_vm.studentId)?_c('StudentAttendance',{attrs:{"studentId":_vm.studentId,"sideBarView":1,"termId":_vm.termId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }